import React from 'react';

import { Container } from './styles';

function ServiceCard({ img, title, items }) {
  return (
    <Container>
      <img src={img} />

      <h3 className="title">{title}</h3>

      <div>
        {items.map(item => (
          <span key={item} className="item">
            {item}
          </span>
        ))}
      </div>
    </Container>
  );
}

export default ServiceCard;
